/**
 * Thin wrapper around the shared ui-kit agent widget.
 *
 * The widget itself lives at `@isg/ui-kit/js/components/agent-widget.js`
 * so every ISG app mounts the same implementation. This file supplies
 * the induction-specific prompts and labels, then delegates.
 */
import { renderAgentWidget } from '@isg/ui-kit';
import { t } from '../i18n/index.js';

// Built at render time — t() must never run at module scope.
function suggestions() {
  return [
    t('ai.suggestion.createWelcome'),
    t('ai.suggestion.listModules'),
    t('ai.suggestion.searchUsers'),
    t('ai.suggestion.conditions'),
    t('ai.suggestion.variables'),
  ];
}

export function renderAIAssistant(container) {
  renderAgentWidget(container, {
    appSlug: 'induction',
    title: t('ai.title'),
    placeholder: t('ai.placeholder'),
    suggestions: suggestions(),
  });
}
